/**
 * @generated SignedSource<<0a7a61dd3898d8c6175ede16eba96aaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineScheduleType = "DAILY" | "MONTHLY" | "WEEKLY";
export type TeamScheduleHistoryScreenCombinedQuery$variables = {
  after?: string | null;
  first?: number | null;
  freq: RoutineScheduleType;
  teamId: string;
};
export type TeamScheduleHistoryScreenCombinedQuery$data = {
  readonly store: {
    readonly team: {
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleHistoryMasterList_team">;
    } | null;
  };
};
export type TeamScheduleHistoryScreenCombinedQuery = {
  response: TeamScheduleHistoryScreenCombinedQuery$data;
  variables: TeamScheduleHistoryScreenCombinedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "freq"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "freq",
    "variableName": "freq"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "calculateNotCompletedStarted",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaskExecutionCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamScheduleHistoryScreenCombinedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamScheduleHistoryMasterList_team"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamScheduleHistoryScreenCombinedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "TeamScheduleConnection",
                "kind": "LinkedField",
                "name": "teamSchedules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamScheduleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "label",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "includeInlineRoutines",
                                "value": true
                              }
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "events",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isTeamScheduleEventOccasion"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v9/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "type": "RoutineOccasion",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskExecutionCheck",
                                    "kind": "LinkedField",
                                    "name": "taskExecution",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RoutineOccasion",
                                        "kind": "LinkedField",
                                        "name": "routineOccasion",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v10/*: any*/),
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v7/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "TeamScheduleInlineRoutineOccasion",
                                "abstractKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": "events(includeInlineRoutines:true)"
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "filters": [
                  "freq"
                ],
                "handle": "connection",
                "key": "TeamScheduleHistoryScreen__teamSchedules",
                "kind": "LinkedHandle",
                "name": "teamSchedules"
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8e70a70b51200f6ba56021dc52451a4d",
    "id": null,
    "metadata": {},
    "name": "TeamScheduleHistoryScreenCombinedQuery",
    "operationKind": "query",
    "text": "query TeamScheduleHistoryScreenCombinedQuery(\n  $teamId: ID!\n  $first: Int\n  $after: String\n  $freq: RoutineScheduleType!\n) {\n  store {\n    team(id: $teamId) {\n      name\n      ...TeamScheduleHistoryMasterList_team\n      id\n    }\n    id\n  }\n}\n\nfragment TeamScheduleHistoryMasterListItem_teamSchedule on TeamSchedule {\n  id\n  label\n  events(includeInlineRoutines: true) {\n    __typename\n    ...TeamScheduleStatusRow_teamScheduleEventOccasion\n    id\n  }\n}\n\nfragment TeamScheduleHistoryMasterList_team on Team {\n  teamSchedules(freq: $freq, first: $first, after: $after) {\n    edges {\n      node {\n        id\n        ...TeamScheduleHistoryMasterListItem_teamSchedule\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment TeamScheduleSectionHeaderStatusDot_routineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  totalTaskExecutionCount\n}\n\nfragment TeamScheduleStatusRow_teamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  ... on RoutineOccasion {\n    ...TeamScheduleSectionHeaderStatusDot_routineOccasion\n  }\n  ... on TeamScheduleInlineRoutineOccasion {\n    taskExecution {\n      routineOccasion {\n        ...TeamScheduleSectionHeaderStatusDot_routineOccasion\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d70c140e98bd3721743eb553d0d2c74";

export default node;
